import React from "react";

const UserLocation = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M16.457 20.36v11.3H5a11.22 11.22 0 013.356-7.99 11.538 11.538 0 018.1-3.31zm0-1.412c-4.748 0-8.593-3.792-8.593-8.474S11.71 2 16.457 2c4.747 0 8.592 3.792 8.592 8.474s-3.845 8.474-8.592 8.474zm12.642 11.056L25.05 34 21 30.004a5.626 5.626 0 01-1.568-2.892 5.577 5.577 0 01.326-3.264 5.667 5.667 0 012.11-2.536 5.785 5.785 0 013.182-.952c1.133 0 2.241.33 3.183.952a5.667 5.667 0 012.11 2.535 5.577 5.577 0 01.326 3.265 5.626 5.626 0 01-1.569 2.892zm-4.05-5.406c-.38 0-.744.149-1.012.414-.269.264-.42.624-.42.998 0 .375.151.734.42.999a1.442 1.442 0 002.025 0 1.402 1.402 0 000-1.997 1.442 1.442 0 00-1.013-.414z"
          fill={fill}
      />
    </svg>
);

export default UserLocation;
